import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
}));

export default function NewsHeader(props) {
    const classes = useStyles();

    return (
        <div className={classes.grow}>            
            <AppBar position="static">
                <Toolbar>
                    <Link to="/news">
                        <IconButton
                            edge="start"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="back">
                            <ArrowBackIcon />
                        </IconButton>
                    </Link>
                    <Typography className="titleHeader" variant="h6" noWrap>
                        {props.translateFunc("NEWS_DETAIL_HEADER_LABEL")}
                    </Typography>
                    <div className={classes.grow} />
                </Toolbar>
            </AppBar>
        </div>
    );
}
